import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { UpdateCardKycStackScreenProps, UpdateCardKycStackRoutes } from './type';
import { CardKycInfoPlacedWebScreen } from './CardKycInfoPlacedWeb.screen';
import { CardKycInfoPlacedNativeScreen } from './CardKycInfoPlacedNative.screen';

export const CardKycInfoPlaced: React.FC<UpdateCardKycStackScreenProps<UpdateCardKycStackRoutes.Placed>> = ({
  navigation,
  route
}) => {
  const { onLayout, data, returnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <CardKycInfoPlacedNativeScreen onClose={onGoBack} data={data} returnData={returnData} refresh={refresh} />;
  }

  return <CardKycInfoPlacedWebScreen onClose={closeModal} onLayout={onLayout} data={data} returnData={returnData} refresh={refresh} />;
};